import React, { useState } from 'react'
import { HelmetProvider } from 'react-helmet-async'
import { Header } from '@/components/Header'
import { DigitalSATCalculator } from '@/components/DigitalSATCalculator'
import { SectionCalculators } from '@/components/SectionCalculators'
import { ACTConverter } from '@/components/ACTConverter'
import { PracticeTestCalculator } from '@/components/PracticeTestCalculator'
import { HowToSection } from '@/components/HowToSection'
import { Footer } from '@/components/Footer'
import { AuthModal } from '@/components/AuthModal'
import { StructuredData } from '@/components/StructuredData'
import { SEOHead } from '@/components/SEOHead'

function App() {
  const [activeTab, setActiveTab] = useState('home')
  const [authModalOpen, setAuthModalOpen] = useState(false)
  const [authMode, setAuthMode] = useState<'login' | 'register' | 'reset'>('login')

  const handleAuthClick = (mode: 'login' | 'register') => {
    setAuthMode(mode)
    setAuthModalOpen(true)
  }

  return (
    <HelmetProvider>
      <SEOHead />
      <StructuredData />
      <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-green-50">
      <Header activeTab={activeTab} onTabChange={setActiveTab} onAuthClick={handleAuthClick} />
      <AuthModal
        isOpen={authModalOpen}
        onClose={() => setAuthModalOpen(false)}
        mode={authMode}
        onSuccess={() => setAuthModalOpen(false)}
      />
      
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 space-y-8">
        {activeTab === 'home' && (
          <>
            <DigitalSATCalculator />
            <SectionCalculators />
            <HowToSection />
          </>
        )}

        {activeTab === 'digital-sat' && (
          <>
            <DigitalSATCalculator />
            <SectionCalculators />
          </>
        )}

        {activeTab === 'act-conversion' && <ACTConverter />}

        {activeTab === 'practice-tests' && <PracticeTestCalculator />}
      </main>

        <Footer />
      </div>
    </HelmetProvider>
  )
}

export default App
